<div class="wccard mb-1 p-3">
  <div class="row">
    <div class="col">
      <p class="heading mb-2">Hightlights</p>
    </div>  
  </div>
  <div class="row mb-2">
    <div class="col">
      <span><i class="fas fa-building" style="color: #2ea7c4;"></i></span>
      <span class="list-heading ml-2">Company Fit</span>
    </div>
  </div>
  <div class="row">
    <ul>
      <li>Relevant skills matched</li>
      <li>Industry matched</li>
      <li>Similar experience / job title</li>
    </ul>
  </div>
  <div class="row mb-2">
    <div class="col">
      <span><i class="fas fa-building" style="color: #2ea7c4;"></i></span>
      <span class="list-heading ml-2">Likely to Move</span>
    </div>
  </div>
  <div class="row">
    <ul>
      <li>Average Job Tenure of 3+ years</li>
      <li>Current Professional Experience of 6+ years</li>
    </ul>
  </div>
  <div class="row mb-1">
    <div class="col">
      <span><i class="fas fa-building" style="color: #2ea7c4;"></i></span>
      <span class="list-heading ml-2">Loyalty</span>
    </div>
  </div>
  <div class="row">
    <ul>
      <li>Has a current experience of over 3+ years</li>
    </ul>
  </div>
</div>
